<template>
  <CustomerCreateEditForm />
</template>
